import React from 'react';
import { ChevronRightIcon, TrendingUpIcon, UsersIcon, EyeIcon, TargetIcon, AwardIcon } from 'lucide-react';
import { PartnersSection } from '../components/PartnersSection';
import Marquee from 'react-fast-marquee';
export function HomePage() {
  const companyLogos = [{
    name: 'Steadily',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4gqEjAA6ntBs1i1jYM8HUK/Steadily_Logo_Transparent_%281%29.png'
  }, {
    name: 'Obie',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hMXrAiLBnCGKayEbaTby2a/Obie_Logo_%282%29.png'
  }, {
    name: 'Prime Corporate Services',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iYUsNoSqpmFdFD7VGKYxrY/PCS_Logo.png'
  }, {
    name: 'TrueBooks',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cVrJNLhna3YMEDCbb18yxW/TrueBooks.png'
  }, {
    name: 'Cornerstone First Mortgage',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nsAAmgqEADSvSKsiqMuLMv/Cornerstone_First_Mortgage_Logo.png'
  }, {
    name: 'SDIRA Wealth',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/w1haKgifKQ2Y8no5TqCXB9/ChatGPT_Image_Oct_22__2025__12_28_34_PM-removebg-preview.png'
  }, {
    name: 'Alliance Wealth Builders',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4kwd4SfXqrsHChtXJMYRre/ChatGPT_Image_Oct_22%2C_2025%2C_12_33_50_PM.png'
  }, {
    name: 'Tractic',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qQUWp5VsCAFswUHzJuLNaG/Tractic_Logo_2B_Pig.png'
  }, {
    name: 'Landing Collective',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rzWjeCfLioyUtmkhuCSKwb/Jay_Johnson_-_Landing_Collective.png'
  }, {
    name: 'Anchora',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8fdrvaBXFmAJeEVpn2ri8C/V0.png'
  }];
  const conferencePhotos = [{
    title: 'Bar Interior with Barrel Vault Ceiling',
    url: 'https://drive.google.com/thumbnail?id=1r7DAMFUQ76i7KqM-LLKBG8VzniIYR0gy&sz=w800'
  }, {
    title: 'Real Estate Lending Presentation',
    url: 'https://drive.google.com/thumbnail?id=1cWlm2R0t4RhPyvurzdL3RbXBoer5MZCG&sz=w800'
  }, {
    title: 'San Diego Housing Market Report Presentation',
    url: 'https://drive.google.com/thumbnail?id=1NDHeCog9vD0CQLVD_zFA40iaaoitNtp7&sz=w800'
  }];
  return <>
      {/* Hero Section */}
      <section className="relative w-full bg-gradient-to-b from-gray-900 to-black py-20 px-4 sm:px-6 lg:px-8" data-id="element-391">
        <div className="max-w-5xl mx-auto text-center" data-id="element-392">
          <div className="flex justify-center mb-8" data-id="element-393">
            <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/2c6dce52-3a64-4bfa-a2a2-ec0b6bf9870c/tactical_investor_mastermind.png" alt="Tactical Investor Mastermind Logo" className="w-40 sm:w-56 h-auto" data-id="element-394" />
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6" data-id="element-395">
            <span className="text-white" data-id="element-396">Tactical Investor</span>
            <span className="block text-[#4a7c59]" data-id="element-397">Mastermind</span>
          </h1>
          <p className="text-xl sm:text-2xl mb-8 text-gray-300 max-w-3xl mx-auto" data-id="element-398">
            We are a mission-driven community of Veterans, First Responders,
            Healthcare Professionals, and their families, working together to
            achieve passive income goals through strategic partnerships.
          </p>
          <div className="mt-10" data-id="element-399">
            <a href="https://calendly.com/gregnamrow/1v1-meeting-tacticalinvestormastermind" target="_blank" rel="noopener noreferrer" className="bg-[#4a7c59] hover:bg-[#3d6649] text-white font-bold py-3 px-8 rounded-md text-lg inline-flex items-center mx-auto" data-id="element-400">
              Join Our Mastermind <ChevronRightIcon className="ml-2 h-5 w-5" data-id="element-401" />
            </a>
          </div>
        </div>
      </section>
      {/* Mission Statement */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-900" data-id="element-402">
        <div className="max-w-5xl mx-auto" data-id="element-403">
          <h2 className="text-3xl sm:text-4xl font-bold mb-10 text-center" data-id="element-404">
            Our Mission
          </h2>
          <div className="bg-black p-8 rounded-lg border border-[#4a7c59] shadow-lg" data-id="element-405">
            <p className="text-xl text-center" data-id="element-406">
              Our mission is to turn service-minded values into real financial
              results through action, alignment, and accountability.
            </p>
          </div>
        </div>
      </section>
      {/* Core Values - Update the existing content with new descriptions */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-black" data-id="element-407">
        <div className="max-w-5xl mx-auto" data-id="element-408">
          <h2 className="text-3xl sm:text-4xl font-bold mb-12 text-center" data-id="element-409">
            Our Core Values
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-410">
            <div className="bg-gray-900 p-6 rounded-lg border-t-4 border-[#4a7c59] flex flex-col items-center text-center" data-id="element-411">
              <div className="bg-[#4a7c59] p-3 rounded-full inline-flex mb-4" data-id="element-412">
                <TrendingUpIcon className="h-8 w-8 text-white" data-id="element-413" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-414">Performance</h3>
              <p className="text-gray-300" data-id="element-415">
                We bring the same dedication to excellence that defines our
                service careers to every investment strategy we deploy.
              </p>
            </div>
            <div className="bg-gray-900 p-6 rounded-lg border-t-4 border-[#4a7c59] flex flex-col items-center text-center" data-id="element-416">
              <div className="bg-[#4a7c59] p-3 rounded-full inline-flex mb-4" data-id="element-417">
                <UsersIcon className="h-8 w-8 text-white" data-id="element-418" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-419">Accountability</h3>
              <p className="text-gray-300" data-id="element-420">
                Like in our service roles, we hold ourselves and each other
                responsible for actions, commitments, and outcomes.
              </p>
            </div>
            <div className="bg-gray-900 p-6 rounded-lg border-t-4 border-[#4a7c59] flex flex-col items-center text-center" data-id="element-421">
              <div className="bg-[#4a7c59] p-3 rounded-full inline-flex mb-4" data-id="element-422">
                <EyeIcon className="h-8 w-8 text-white" data-id="element-423" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-424">Transparency</h3>
              <p className="text-gray-300" data-id="element-425">
                We maintain the highest standards of integrity, sharing both
                successes and learning experiences to grow together.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Company Logos Marquee */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-900" data-id="element-426">
        <div className="max-w-7xl mx-auto" data-id="element-427">
          <h3 className="text-2xl font-bold mb-8 text-center text-gray-400" data-id="element-428">
            Trusted By Industry Leaders
          </h3>
          <Marquee gradient={false} speed={40} className="py-4" data-id="element-429">
            {companyLogos.map((logo, index) => <div key={index} className="mx-8 flex items-center justify-center p-6 h-36 w-48" data-id="element-430">
                <img src={logo.url} alt={`${logo.name} logo`} className="max-h-full max-w-full object-contain brightness-0 invert opacity-70" style={{
              mixBlendMode: 'screen'
            }} data-id="element-431" />
              </div>)}
          </Marquee>
        </div>
      </section>
      {/* Call to Action Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-black" data-id="element-432">
        <div className="max-w-4xl mx-auto text-center" data-id="element-433">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6" data-id="element-434">
            Ready to Transform Your Financial Future?
          </h2>
          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-435">
            Join a community of service professionals who are building wealth
            through strategic partnerships and proven investment strategies.
          </p>
          <a href="https://calendly.com/gregnamrow/1v1-meeting-tacticalinvestormastermind" target="_blank" rel="noopener noreferrer" className="bg-[#4a7c59] hover:bg-[#3d6649] text-white font-bold py-3 px-8 rounded-md text-lg inline-flex items-center" data-id="element-436">
            Join Our Mastermind <ChevronRightIcon className="ml-2 h-5 w-5" data-id="element-437" />
          </a>
        </div>
      </section>
      {/* Benefits Section - Update descriptions */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-900" data-id="element-438">
        <div className="max-w-5xl mx-auto" data-id="element-439">
          <h2 className="text-3xl sm:text-4xl font-bold mb-12 text-center" data-id="element-440">
            Why Join Our Ranks
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-441">
            <div className="flex items-start" data-id="element-442">
              <div className="mr-4 mt-1" data-id="element-443">
                <TargetIcon className="h-6 w-6 text-[#4a7c59]" data-id="element-444" />
              </div>
              <div data-id="element-445">
                <h3 className="text-xl font-bold mb-2" data-id="element-446">Strategic Advantage</h3>
                <p className="text-gray-300" data-id="element-447">
                  Leverage the collective intelligence and discipline of
                  service-oriented professionals to identify and execute winning
                  investment strategies.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-448">
              <div className="mr-4 mt-1" data-id="element-449">
                <UsersIcon className="h-6 w-6 text-[#4a7c59]" data-id="element-450" />
              </div>
              <div data-id="element-451">
                <h3 className="text-xl font-bold mb-2" data-id="element-452">
                  Service-Minded Community
                </h3>
                <p className="text-gray-300" data-id="element-453">
                  Connect with like-minded professionals who understand the
                  unique challenges and mindset of those dedicated to service.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-454">
              <div className="mr-4 mt-1" data-id="element-455">
                <TrendingUpIcon className="h-6 w-6 text-[#4a7c59]" data-id="element-456" />
              </div>
              <div data-id="element-457">
                <h3 className="text-xl font-bold mb-2" data-id="element-458">Accelerated Growth</h3>
                <p className="text-gray-300" data-id="element-459">
                  Achieve your passive income goals faster through structured
                  accountability and proven investment frameworks tailored to
                  service professionals.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-460">
              <div className="mr-4 mt-1" data-id="element-461">
                <AwardIcon className="h-6 w-6 text-[#4a7c59]" data-id="element-462" />
              </div>
              <div data-id="element-463">
                <h3 className="text-xl font-bold mb-2" data-id="element-464">Elite Standards</h3>
                <p className="text-gray-300" data-id="element-465">
                  Join a group that maintains the same high standards in
                  financial strategy that you uphold in your service to others.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <PartnersSection data-id="element-466" />
      {/* 2026 In-Person Conference Photos */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-black" data-id="element-467">
        <div className="max-w-7xl mx-auto" data-id="element-468">
          <div className="text-center mb-12" data-id="element-469">
            <h2 className="text-3xl sm:text-4xl font-bold mb-4" data-id="element-470">
              2026 In-Person Conference
            </h2>
            <p className="text-xl text-gray-400" data-id="element-471">
              A look at our most recent Mastermind gathering.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-472">
            {[{
            title: 'Bar Interior with Barrel Vault Ceiling',
            url: 'https://drive.google.com/thumbnail?id=1r7DAMFUQ76i7KqM-LLKBG8VzniIYR0gy&sz=w800'
          }, {
            title: 'Group Dinner at Restaurant',
            url: 'https://drive.google.com/thumbnail?id=1Ym5KRj27bRE-1HpGcaZZiV3bfOtqmPwD&sz=w800'
          }, {
            title: 'Office Hallway with US Map Pin Board',
            url: 'https://drive.google.com/thumbnail?id=1X-s-4NjQBMiwgBmisKV6JfRLHF0hby2h&sz=w800'
          }, {
            title: 'Real Estate Lending Presentation',
            url: 'https://drive.google.com/thumbnail?id=1cWlm2R0t4RhPyvurzdL3RbXBoer5MZCG&sz=w800'
          }, {
            title: 'San Diego Housing Market Report Presentation',
            url: 'https://drive.google.com/thumbnail?id=1NDHeCog9vD0CQLVD_zFA40iaaoitNtp7&sz=w800'
          }, {
            title: 'STEP National Headquarters Sign',
            url: 'https://drive.google.com/thumbnail?id=1HE8YA8Qs9_GwehxtMCD8JIn23sNRMnpB&sz=w800'
          }, {
            title: 'STEP Warehouse Volunteers with Supplies',
            url: 'https://drive.google.com/thumbnail?id=1xrFVra5J_KVLe2QBv9sfwMduHY4w5i8r&sz=w800'
          }, {
            title: 'Three Friends Posing at Beach Sunset',
            url: 'https://drive.google.com/thumbnail?id=1zyenqE8nYfOhrb2DB4AxbEa1j_UsfgVW&sz=w800'
          }, {
            title: 'Volunteer Sorting Supplies in Storage Room',
            url: 'https://drive.google.com/thumbnail?id=1Ye_0abtJQJhn9c-A1WLC8aw4PlRoS0LG&sz=w800'
          }, {
            title: 'Woman Presenting Self Storage Business Overview',
            url: 'https://drive.google.com/thumbnail?id=1aXVeOYkrzK66U-khJsNPkLPhsGh0gQfT&sz=w800'
          }].map((photo, index) => <div key={index} className="relative overflow-hidden rounded-lg border border-gray-800 hover:border-[#4a7c59] transition-colors duration-300 aspect-video" data-id="element-473">
                <img src={photo.url} alt={photo.title} className="w-full h-full object-cover" data-id="element-474" />
              </div>)}
          </div>
        </div>
      </section>
    </>;
}